/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGridGoldenratio = createReactComponent("outline", "grid-goldenratio", "IconGridGoldenratio", [["path", { "d": "M3 10h18", "key": "svg-0" }], ["path", { "d": "M3 14h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M14 3v18", "key": "svg-3" }]]);

export { IconGridGoldenratio as default };
//# sourceMappingURL=IconGridGoldenratio.mjs.map
